import { ComposableMap, Geographies, Geography, Marker } from "react-simple-maps";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { useLang } from "@/lib/i18n";

const GEO_URL = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

const MARKERS = [
  { name: "Abuja (HQ)", coordinates: [7.4951, 9.0579], hq: true },
  { name: "Lagos", coordinates: [3.3792, 6.5244] },
  { name: "Johannesburg", coordinates: [28.0473, -26.2041] },
  { name: "Dubai", coordinates: [55.2708, 25.2048] },
  { name: "Mumbai", coordinates: [72.8777, 19.076] },
  { name: "Shanghai", coordinates: [121.4737, 31.2304] },
  { name: "Rotterdam", coordinates: [4.4792, 51.9225] },
  { name: "London", coordinates: [-0.1276, 51.5072] },
  { name: "New York", coordinates: [-74.006, 40.7128] },
  { name: "São Paulo", coordinates: [-46.6333, -23.5505] },
];

export const GlobalReach = () => {
  const { t } = useLang();
  return (
  <section id="global-reach" data-testid="global-reach-section" className="py-24 md:py-32">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <Eyebrow>{t.reach.eyebrow}</Eyebrow>
        <div className="flex flex-wrap items-end justify-between gap-6 mb-14">
          <h2 className="text-3xl md:text-4xl tracking-tight font-bold text-[#F4F6F8] max-w-xl">
            {t.reach.title}
          </h2>
          <p className="text-base text-[#94A3B8] max-w-sm">
            {t.reach.sub}
          </p>
        </div>
      </Reveal>

      <Reveal delay={0.1}>
        <div data-testid="world-map" className="relative border border-[#1E293B] bg-surface overflow-hidden">
          <ComposableMap
            projectionConfig={{ scale: 155, center: [15, 12] }}
            style={{ width: "100%", height: "auto" }}
          >
            <Geographies geography={GEO_URL}>
              {({ geographies }) =>
                geographies.map((geo) => (
                  <Geography
                    key={geo.rsmKey}
                    geography={geo}
                    fill="#111A2C"
                    stroke="#1E293B"
                    strokeWidth={0.5}
                    style={{
                      default: { outline: "none" },
                      hover: { outline: "none", fill: "#1A2438" },
                      pressed: { outline: "none" },
                    }}
                  />
                ))
              }
            </Geographies>
            {MARKERS.map((m) => (
              <Marker key={m.name} coordinates={m.coordinates}>
                <circle r={m.hq ? 6 : 4} fill="#D4AF37" className="animate-pulse-ring" style={{ transformOrigin: "center" }} opacity={0.5} />
                <circle r={m.hq ? 4 : 2.6} fill="#D4AF37" stroke="#060A14" strokeWidth={1} />
                {m.hq && (
                  <text textAnchor="middle" y={-12} style={{ fill: "#D4AF37", fontSize: 11, fontWeight: 700, letterSpacing: 2 }}>
                    ABUJA HQ
                  </text>
                )}
              </Marker>
            ))}
          </ComposableMap>
          <div className="absolute bottom-0 inset-x-0 h-16 bg-gradient-to-t from-surface to-transparent pointer-events-none" />
        </div>
      </Reveal>

      <Reveal delay={0.15}>
        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          {t.reach.regions.map((r, i) => (
            <span
              key={r}
              data-testid={`region-chip-${i + 1}`}
              className="inline-flex items-center gap-2 border border-[#1E293B] px-5 py-2.5 text-sm text-[#F4F6F8] hover:border-gold/50 transition-colors duration-200"
            >
              <span className="font-display text-xs text-gold">{String(i + 1).padStart(2, "0")}</span> {r}
            </span>
          ))}
        </div>
      </Reveal>
    </div>
  </section>
  );
};
